import React, { useState, useEffect, useRef } from "react";
import { INDEX_URL, CUST, icons } from "../../helpers/constants";
import { Card, Collapse, Dialog } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { staticSort } from "../../helpers/helperFunctions";
import { AnimatePresence, motion } from "framer-motion";

const SearchbarNew = ({ searchWord, submitSearch }) => {
	const { t } = useTranslation();
	const [searchKey, setSearchKey] = useState("");
	const [isOpen, setIsOpen] = useState(false);
	const [activeSearch, setActiveSearch] = useState(false)
	const [expanded, setExpanded] = useState("100%")

	const inputRef = useRef(null);
	const BUTTON = 36; // px

	//const EXPANDED = "100%"; // or "420px"

	const toggleSearch = () => {
		if(activeSearch){
			setSearchKey("")
			submitSearch?.("")
			setActiveSearch(false)
		}else{
			setIsOpen((v) => !v);
		}
	}

	useEffect(() => {
		if(searchWord === ""){
			setSearchKey("")
			setActiveSearch(false)
		}
	}, [searchWord])



	useEffect(() => {
		if (isOpen) {
			const id = setTimeout(() => inputRef.current?.focus(), 120);
			return () => clearTimeout(id);
		}
	}, [isOpen]);

	const passSearch = (word) => {
		setActiveSearch(true)
		submitSearch?.(word)
		setExpanded("auto")
	}

	const onKeyDown = (e) => {
		if (e.key === "Enter" && searchKey.trim()) passSearch?.(searchKey.trim());
	};

	return (
			<motion.div
				layout
				className="position-relative bg-white full-rounded overflow-hidden border-none"
				initial={{ width: BUTTON }}
				animate={{ width: isOpen ? expanded : BUTTON }}
				transition={{ type: "spring", stiffness: 240, damping: 24 }}
				style={{
				}}
				onClick={() => {
					if (!isOpen) toggleSearch();
				}}
			>
				{/* Input expands to the LEFT; reserve space for the icon on the right */}
				<motion.input
					ref={inputRef}
					autoComplete="off"
					type="text"
					disabled={activeSearch}
					className="form-control bg-white"
					value={searchKey}
					onChange={(e) => setSearchKey(e.target.value)}
					onKeyDown={onKeyDown}
					placeholder={t("search.search")}
					initial={{ opacity: 0 }}
					animate={{ opacity: isOpen ? 1 : 0 }}
					transition={{ duration: 0.15 }}
					style={{
						pointerEvents: isOpen ? "auto" : "none",
					}}
					onClick={(e) => e.stopPropagation()}
				/>

				{/* Fixed 36x36 icon on the right */}
				<button
					type="button"
					className="position-absolute bg-transparent border-none top-0 end-0 btn-search"
					aria-label="Search"
					onClick={(e) => {
						e.stopPropagation();
						toggleSearch();
					}}
				>
					<img src={activeSearch ? icons.close : icons.search} className={`size_15 grey-blue-icon`} alt="Search" style={{ width: 15, height: 15, pointerEvents: "none" }} />
				</button>
			</motion.div>
	);
};

export default SearchbarNew;
